module.exports = __webpack_public_path__ + "static/media/chevron-left.c7552ce8.svg";